import { ELOTypeEnum } from '../../../../../../../shared/GameEnums.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
import { RankedUserStateController } from '@colonist/leaderboard-types';
import { UIAjaxWrapper } from '../../../../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../../../../../shared/scripts/network/UIAPIEndpoints.ts';
import { SocketMatchmakingSend } from '../../../../../../shared/scripts/socket/SocketMatchmakingSend.ts';
import { COLONIST_VERSION } from '@colonist/types';
import { UIVideoAdController } from '../../../../../../shared/scripts/ui_ad/UIVideoAdController.ts';
export class UIMMatchmakingActionsController {
    sendFindGameMessageToServer(selectedMatchType) {
        const matchmakingRequest = {
            clientVersion: COLONIST_VERSION,
            matchType: selectedMatchType
        };
        const adShown = this.videoAdController.triggerMatchmakingVideoAd(selectedMatchType, this.findGameRankedStates, false, matchmakingRequest);
        if (adShown) return;
        SocketMatchmakingSend.enterMatchmaker(matchmakingRequest);
    }
    async fetchRankedState() {
        const displayError = false;
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFindGameState(), undefined, undefined, displayError);
        if (response == undefined) return;
        if (response.isSuccess == false) return;
        this.findGameRankedStates = response.json;
    }
    getEloFromRankedGame() {
        const matchType = this.rankedStateMatchType;
        if (matchType == MatchmakingMatchTypes.RankedClassic1v1) return ELOTypeEnum.VisibleRanked1v1;
        if (matchType == MatchmakingMatchTypes.RankedClassic4P) return ELOTypeEnum.VisibleRanked4PClassic;
        if (matchType == MatchmakingMatchTypes.RankedCitiesAndKnights4P) return ELOTypeEnum.VisibleRankedCitiesAndKnights4P;
        if (matchType == MatchmakingMatchTypes.RankedRush4P) return ELOTypeEnum.VisibleRanked4PRush;
        return ELOTypeEnum.Inactive;
    }
    getRankedState() {
        const eloType = this.getEloFromRankedGame();
        const gameType = this.findGameRankedStates.find((rankedGameState)=>{
            if (!rankedGameState.active) return false;
            if (rankedGameState.eloType != eloType) return false;
            return true;
        });
        if (!(gameType === null || gameType === void 0 ? void 0 : gameType.rankedState)) return;
        return RankedUserStateController.deserialize(gameType.rankedState);
    }
    getRankedPlacementText(matchType) {
        this.rankedStateMatchType = matchType;
        const rankedState = this.getRankedState();
        if (!rankedState) return;
        return rankedState.getFindGamePopupStatusText();
    }
    constructor(){
        this.findGameRankedStates = [];
        this.videoAdController = new UIVideoAdController();
    }
}
